module.exports = __webpack_public_path__ + "img/deeplink_step1.83a3af69.svg";